import {Action, ReducerBuilder} from "redux-ts";
import {Reducer} from "platform/redux/Reducer";
import {EduFilterValue, EduTradingReduxState, PlaylistInfo} from "core/redux/eduTrading/EduTradingReduxState";
import EduTradingEngine from "core/engine/EduTradingEngine";
import Platform from "platform/Platform";
import {ServiceType} from "enum/ServiceType";
import {
    EduTradingFetchArticlesType,
    EduTradingFetchCryptoCalendarEventsType,
    EduTradingFetchCurrencyStrengthMeterType,
    EduTradingFetchEconomicCalendarEventsType,
    EduTradingFetchGlossaryType,
    EduTradingFetchMarketVideosType,
    // EduTradingFetchSignalsType,
    EduTradingFetchTrendAnalysisType,
    EduTradingFiltersPayload,
    EduTradingSetActiveChartTab,
    EduTradingSetActiveChartTabPayload,
    EduTradingSetActiveNewsTab,
    EduTradingSetActiveNewsTabPayload,
    EduTradingSetActiveTradeContentTab,
    EduTradingSetActiveTradeContentTabPayload,
    EduTradingSetArticles,
    EduTradingSetArticlesPayload,
    EduTradingSetCryptoCalendarDateFilter,
    EduTradingSetCryptoCalendarDateFilterPayload,
    EduTradingSetCryptoCalendarEvents,
    EduTradingSetCryptoCalendarEventsPayload,
    EduTradingSetCryptoCalendarFilters,
    EduTradingSetCryptoCalendarPeriod,
    EduTradingSetCryptoCalendarPeriodPayload,
    EduTradingSetCurrencyStrengthMeter,
    EduTradingSetCurrencyStrengthMeterPayload,
    EduTradingSetEconomicCalendarDateFilter,
    EduTradingSetEconomicCalendarDateFilterPayload,
    EduTradingSetEconomicCalendarEvents,
    EduTradingSetEconomicCalendarEventsPayload,
    EduTradingSetEconomicCalendarFilters,
    EduTradingSetEconomicCalendarFiltersPayload,
    EduTradingSetEconomicCalendarPeriod,
    EduTradingSetEconomicCalendarPeriodPayload,
    EduTradingSetGlossary,
    EduTradingSetGlossaryPayload,
    EduTradingSetLoading,
    EduTradingSetMarketSearchVideos,
    EduTradingSetMarketSearchVideosPayload,
    EduTradingSetTrendAnalisys,
    EduTradingSetTrendAnalisysPayload,
    EduTradingSetTrendAnalysisMarket,
    EduTradingSetTrendAnalysisMarketPayload,
    EduTradingSetActiveMarketVideoTab,
    EduTradingSetActiveMarketVideoTabPayload,
    EduTradingSetActiveTradeMobileTab,
    EduTradingSetActiveTradeMobileTabPayload,
    EduTradingSetAvailableMobileChart,
    EduTradingSetShowSearchContent,
    EduTradingSetShowSearchContentPayload,
    EduTradingSetSearchValue,
    EduTradingSetSearchValuePayload,
    EduTradingSetPackageTreeContent,
    EduTradingSetPackageTreeContentPayload,
    EduTradingSetActivePackage,
    EduTradingSetActivePackagePayload,
    EduTradingSetLoadingTree,
    EduTradingSetPackages,
    EduTradingSetPackagesPayload,
    EduTradingSetShowNotifications,
    EduTradingSetShowNotificationsPayload,
    EduTradingCompleteLessonType,
    EduTradingSetLessonsCount,
    EduTradingSetLessonsCountPayload,
    EduTradingSetAcademyPlaylistProgress,
    EduTradingSetAcademyPlaylistProgressPayload,
    EduTradingCompleteLesson,
    EduTradingCompleteLessonPayload,
    EduTradingSetLoadingPayload,
    EduTradingSetPackagesContent,
    EduTradingSetPackagesContentPayload,
    EduTradingSetActiveBroker,
    EduTradingSetActiveBrokerPayload,
    EduTradingGetActivePackageType,
    EduTradingSetNavigationMenuExpanded,
    EduTradingSetNavigationMenuExpandedPayload,
    EduTradingSetNavigationMenuActive,
    EduTradingSetNavigationMenuActivePayload,
    EduTradingSetTrendAnalysisResolution,
    EduTradingSetTrendAnalysisResolutionPayload,
    EduTradingSetTrendAnalysisAsset,
    EduTradingSetTrendAnalysisAssetPayload,
} from "core/redux/eduTrading/EduTradingReduxActions";
import {EduTradingTradeContentTab} from "enum/EduTradingTradeContentTab";
import {EduTradingChartTab} from "enum/EduTradingChartTab";
import {TSMap} from "typescript-map";
import {EduTradingEconomicCalendarPeriod} from "protocol/edutrading/EduTradingEconomicCalendarPeriod";
import {
    SelectFollowedAccountPayload,
    SetFollowedAccount,
    SetFollowedAccountPayload,
    SetFollowedAccounts,
    SetFollowedAccountsPayload, SetSelectedPartnerAccountId
} from "core/redux/partner/PartnerReduxActions";
import {EduTradingCryptoCalendarPeriod} from "protocol/edutrading/EduTradingCryptoCalendarPeriod";
import {EduTradingMarketVideoType} from "protocol/edutrading/EduTradingMarketVideoType";
import {EduTradingMarketVideo} from "protocol/edutrading/EduTradingMarketVideosResponse";
import Utils from "platform/util/Utils";
import {EduTradingNewsCategoryType} from "protocol/edutrading/EduTradingNewsCategoryType";
import {EduTradingArticle} from "protocol/edutrading/EduTradingArticlesResponse";
import {BooleanPayload} from "core/redux/StoreActions";
import {SetAuthStatusType} from "core/redux/auth/AuthReduxActions";
import {EduTradingLessonsCountType} from "enum/EduTradingLessonsCountType";
import {LockedDataConfig} from "core/redux/eduTrading/EduTradingLockedDataConfig";
import {LoadLanguageType, SetLangCodeType} from "platform/redux/translation/TranslationActions";
import {EduTreeCourse} from "protocol/edutrading/GetEducationalContentTree";
import {Configuration} from "core/configuration/Configuration";
import {RouteType} from "core/router/Routes";
import {EduTradingCurrencyStrengthType} from "protocol/edutrading/EduTradingCurrencyStrengthType";

const initialState = (): EduTradingReduxState => {
    const {brokersReviewUrl} = Platform.config<Configuration>();
    return {
        Brokers: [
            {id: 75, name: "200Invest", logo: "Invest200", rating: 4.5},
            {id: 65, name: "Finansero", rating: 4.5},
            {id: 41, name: "Fortissio", rating: 4.5},
            {id: 56, name: "FXGM CO ZA", logo: "FXGMza", rating: 4.5},
            {id: 73, name: "Tradit", rating: 4.5},
            {id: 63, name: "Warren Bowie & Smith", logo: "WBS", rating: 4.5},
            {id: 40, name: "XLNTrade", rating: 4.5},
            {id: 67, name: "Zenstox", rating: 4.5},
            {id: 66, name: "Xcite", rating: 4.5},
        ],
        ActiveChartTab: EduTradingChartTab.Chart,
        ActiveTradeContentTab: brokersReviewUrl ? EduTradingTradeContentTab.Review : EduTradingTradeContentTab.Connect,
        ActiveTradeMobileTab: EduTradingTradeContentTab.Trade,
        Articles: new TSMap<EduTradingNewsCategoryType, EduTradingArticle[]>(),
        MinPackageConfig: {},
        Packages: [],
        PackagesContent: new TSMap(),
        Courses: [],
        EBooks: [],
        MarketAnalysis: [],
        MarketScanners: [],
        NavigationMenuExpanded: new TSMap(),
        NavigationMenuActive: {
            routeType: RouteType.Academy,
            params: {}
        },
        Tools: [],
        Events: [],
        economicCalendarPeriod: EduTradingEconomicCalendarPeriod.TodayUpcoming,
        economicCalendarFilters: new TSMap<string, EduFilterValue[]>(),
        economicCalendarDateFilter: null,
        cryptoEvents: [],
        cryptoCalendarPeriod: EduTradingCryptoCalendarPeriod.ThisWeek,
        cryptoCalendarFilters: new TSMap<string, EduFilterValue[]>(),
        cryptoCalendarDateFilter: null,
        marketVideos: new TSMap<EduTradingMarketVideoType, EduTradingMarketVideo[]>(),
        currencyStrength: [],
        glossary: [],
        trendAnalysis: [],
        NewsActiveTab: new TSMap<EduTradingNewsCategoryType, string>(),
        trendAnalysisMarket: "",
        MarketVideosActiveTab: new TSMap<EduTradingMarketVideoType, string>(),
        ShowSearchContent: new TSMap<string, boolean>(),
        SearchValue: new TSMap<string, string>(),
        LessonsCount: new TSMap<EduTradingLessonsCountType, number>(),
        AcademyPlaylistProgress: new TSMap<number, PlaylistInfo>(),
        LockedData: LockedDataConfig(),
        loading: new TSMap<RouteType, boolean>(),
        trendAnalysisResolution: EduTradingCurrencyStrengthType.M5
    }
}

export default class EduTradingReducer extends Reducer<EduTradingReduxState> {

    private static _instance: EduTradingReducer;

    public static instance(): EduTradingReducer {
        return this._instance || (this._instance = new this());
    }

    private constructor() {
        super();
        const engine: EduTradingEngine = Platform.engine(ServiceType.EduTrading);
        this._middlewareActions.set(SetAuthStatusType, engine.doSetAuthStatus);
        this._middlewareActions.set(SetLangCodeType, engine.onSetLanguage);
        this._middlewareActions.set(EduTradingFetchArticlesType, engine.DoGetArticles);
        this._middlewareActions.set(EduTradingGetActivePackageType, engine.DoGetActivePackage);
        this._middlewareActions.set(EduTradingFetchEconomicCalendarEventsType, engine.DoGetEconomicCalendarEvents);
        this._middlewareActions.set(EduTradingFetchCryptoCalendarEventsType, engine.DoGetCryptoCalendarEvents);
        this._middlewareActions.set(EduTradingFetchMarketVideosType, engine.DoGetMarketVideos);
        this._middlewareActions.set(EduTradingFetchCurrencyStrengthMeterType, engine.DoGetCurrencyStrengthMeter);
        this._middlewareActions.set(EduTradingFetchGlossaryType, engine.DoGetGlossary);
        this._middlewareActions.set(EduTradingFetchTrendAnalysisType, engine.DoGetTrendAnalysis);
        this._middlewareActions.set(EduTradingCompleteLessonType, engine.DoCompleteLesson);
    }

    public get name(): string {
        return "eduTrading";
    }

    protected setup(builder: ReducerBuilder<EduTradingReduxState>): void {
        builder
            .init(initialState())
            .handle(SetFollowedAccounts, (state: EduTradingReduxState, {payload}: Action<SetFollowedAccountsPayload>) => {
                const {brokersReviewUrl} = Platform.config<Configuration>();
                const activeTab: EduTradingTradeContentTab = payload.Accounts.size() > 0 ? EduTradingTradeContentTab.Trade
                    : brokersReviewUrl ? EduTradingTradeContentTab.Review : EduTradingTradeContentTab.Connect
                return Object.assign({}, state, {
                    ActiveTradeContentTab: activeTab,
                    ActiveTradeMobileTab: payload.Accounts.size() > 0 ? EduTradingTradeContentTab.Brokers : activeTab
                });
            })
            .handle(SetFollowedAccount, (state: EduTradingReduxState, {}: Action<SetFollowedAccountPayload>) => {
                return Object.assign({}, state, {
                    ActiveTradeContentTab: EduTradingTradeContentTab.Trade,
                });
            })
            .handle(EduTradingSetActivePackage, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActivePackagePayload>) => {
                return Object.assign({}, state, {
                    ActivePackage: payload.Package,
                });
            })
            .handle(EduTradingSetPackages, (state: EduTradingReduxState, {payload}: Action<EduTradingSetPackagesPayload>) => {
                return Object.assign({}, state, {
                    Packages: payload.Packages,
                });
            })
            .handle(EduTradingSetPackagesContent, (state: EduTradingReduxState, {payload}: Action<EduTradingSetPackagesContentPayload>) => {
                return Object.assign({}, state, {
                    PackagesContent: payload.PackagesContent,
                });
            })
            .handle(EduTradingSetActiveBroker, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveBrokerPayload>) => {
                return Object.assign({}, state, {
                    ActiveBroker: payload.broker,
                });
            })
            .handle(SetSelectedPartnerAccountId, (state: EduTradingReduxState, {payload}: Action<SelectFollowedAccountPayload>) => {
                return Object.assign({}, state, {
                    ActiveBroker: state.Brokers.filter(broker => broker.id === payload.account.BrandId)[0],
                });
            })
            .handle(EduTradingSetActiveChartTab, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveChartTabPayload>) => {
                return Object.assign({}, state, {
                    ActiveChartTab: payload.Tab,
                });
            })
            .handle(EduTradingSetActiveTradeContentTab, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveTradeContentTabPayload>) => {
                return Object.assign({}, state, {
                    ActiveTradeContentTab: payload.Tab,
                });
            })
            .handle(EduTradingSetNavigationMenuActive, (state: EduTradingReduxState, {payload}: Action<EduTradingSetNavigationMenuActivePayload>) => {
                return Object.assign({}, state, {
                    NavigationMenuActive: payload,
                });
            })
            .handle(EduTradingSetActiveTradeMobileTab, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveTradeMobileTabPayload>) => {
                return Object.assign({}, state, {
                    ActiveTradeMobileTab: payload.Tab,
                });
            })
            .handle(EduTradingSetAvailableMobileChart, (state: EduTradingReduxState, {payload}: Action<BooleanPayload>) => {
                return Object.assign({}, state, {
                    AvailableMobileChart: payload.value,
                });
            })
            .handle(EduTradingSetPackageTreeContent, (state: EduTradingReduxState, {payload}: Action<EduTradingSetPackageTreeContentPayload>) => {
                return Object.assign({}, state, {
                    Courses: payload.Courses,
                    EBooks: payload.EBooks,
                    MarketAnalysis: payload.MarketAnalysis,
                    MarketScanners: payload.MarketScanners,
                    Tools: payload.Tools,
                    MinPackageConfig: payload.MinPackageConfig
                });
            })
            .handle(EduTradingSetArticles, (state: EduTradingReduxState, {payload}: Action<EduTradingSetArticlesPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.Articles.set(payload.articleType, payload.Articles);
                return newState;
            })
            .handle(EduTradingSetEconomicCalendarEvents, (state: EduTradingReduxState, {payload}: Action<EduTradingSetEconomicCalendarEventsPayload>) => {
                return Object.assign({}, state, {
                    Events: payload.Events,
                });
            })
            .handle(EduTradingSetEconomicCalendarPeriod, (state: EduTradingReduxState, {payload}: Action<EduTradingSetEconomicCalendarPeriodPayload>) => {
                return Object.assign({}, state, {
                    economicCalendarPeriod: payload.period,
                });
            })
            .handle(EduTradingSetEconomicCalendarFilters, (state: EduTradingReduxState, {payload}: Action<EduTradingSetEconomicCalendarFiltersPayload>) => {
                return Object.assign({}, state, {
                    economicCalendarFilters: payload.filters,
                });
            })
            .handle(EduTradingSetEconomicCalendarDateFilter, (state: EduTradingReduxState, {payload}: Action<EduTradingSetEconomicCalendarDateFilterPayload>) => {
                return Object.assign({}, state, {
                    economicCalendarDateFilter: payload.dateFilter,
                });
            })
            .handle(EduTradingSetLoadingTree, (state: EduTradingReduxState, {payload}: Action<BooleanPayload>) => {
                return Object.assign({}, state, {
                    LoadingTree: payload.value,
                });
            })
            .handle(EduTradingSetLoading, (state: EduTradingReduxState, {payload}: Action<EduTradingSetLoadingPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.loading.set(payload.page, payload.value);
                return newState;
            })
            .handle(EduTradingSetNavigationMenuExpanded, (state: EduTradingReduxState, {payload}: Action<EduTradingSetNavigationMenuExpandedPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.NavigationMenuExpanded.set(payload.routeType, payload.expanded);
                return newState;
            })
            .handle(EduTradingSetCryptoCalendarEvents, (state: EduTradingReduxState, {payload}: Action<EduTradingSetCryptoCalendarEventsPayload>) => {
                return Object.assign({}, state, {
                    cryptoEvents: payload.cryptoEvents,
                });
            })
            .handle(EduTradingSetCryptoCalendarPeriod, (state: EduTradingReduxState, {payload}: Action<EduTradingSetCryptoCalendarPeriodPayload>) => {
                return Object.assign({}, state, {
                    cryptoCalendarPeriod: payload.period,
                });
            })
            .handle(EduTradingSetCryptoCalendarDateFilter, (state: EduTradingReduxState, {payload}: Action<EduTradingSetCryptoCalendarDateFilterPayload>) => {
                return Object.assign({}, state, {
                    cryptoCalendarDateFilter: payload.dateFilter,
                });
            })
            .handle(EduTradingSetCryptoCalendarFilters, (state: EduTradingReduxState, {payload}: Action<EduTradingFiltersPayload>) => {
                return Object.assign({}, state, {
                    cryptoCalendarFilters: payload.filters,
                });
            })
            .handle(EduTradingSetMarketSearchVideos, (state: EduTradingReduxState, {payload}: Action<EduTradingSetMarketSearchVideosPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.marketVideos.set(payload.videoType, payload.videos);
                return newState;
            })
            .handle(EduTradingSetCurrencyStrengthMeter, (state: EduTradingReduxState, {payload}: Action<EduTradingSetCurrencyStrengthMeterPayload>) => {
                return Object.assign({}, state, {
                    currencyStrength: payload.currencies,
                });
            })
            .handle(EduTradingSetGlossary, (state: EduTradingReduxState, {payload}: Action<EduTradingSetGlossaryPayload>) => {
                return Object.assign({}, state, {
                    glossary: payload.glossary,
                });
            })
            .handle(EduTradingSetTrendAnalisys, (state: EduTradingReduxState, {payload}: Action<EduTradingSetTrendAnalisysPayload>) => {
                return Object.assign({}, state, {
                    trendAnalysis: payload.trendAnalysis,
                });
            })
            .handle(EduTradingSetActiveNewsTab, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveNewsTabPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.NewsActiveTab.set(payload.categoryType, payload.tab);
                return newState;
            })
            .handle(EduTradingSetTrendAnalysisMarket, (state: EduTradingReduxState, {payload}: Action<EduTradingSetTrendAnalysisMarketPayload>) => {
                return Object.assign({}, state, {
                    trendAnalysisMarket: payload.market,
                });
            })
            .handle(EduTradingSetActiveMarketVideoTab, (state: EduTradingReduxState, {payload}: Action<EduTradingSetActiveMarketVideoTabPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.MarketVideosActiveTab.set(payload.category, payload.tab);
                return newState;
            })
            .handle(EduTradingSetShowSearchContent, (state: EduTradingReduxState, {payload}: Action<EduTradingSetShowSearchContentPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.ShowSearchContent.set(payload.page, payload.show);
                return newState;
            })
            .handle(EduTradingSetSearchValue, (state: EduTradingReduxState, {payload}: Action<EduTradingSetSearchValuePayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.SearchValue.set(payload.page, payload.value);
                return newState;
            })
            .handle(EduTradingSetShowNotifications, (state: EduTradingReduxState, {payload}: Action<EduTradingSetShowNotificationsPayload>) => {
                return Object.assign({}, state, {
                    ShowNotifications: payload.value,
                });
            })
            .handle(EduTradingSetLessonsCount, (state: EduTradingReduxState, {payload}: Action<EduTradingSetLessonsCountPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                newState.LessonsCount.set(EduTradingLessonsCountType.All, payload.all);
                newState.LessonsCount.set(EduTradingLessonsCountType.Completed, payload.completed);
                return newState;
            })
            .handle(EduTradingSetAcademyPlaylistProgress, (state: EduTradingReduxState, {payload}: Action<EduTradingSetAcademyPlaylistProgressPayload>) => {
                return Object.assign({}, state, {
                    AcademyPlaylistProgress: payload.data,
                });
            })
            .handle(EduTradingCompleteLesson, (state: EduTradingReduxState, {payload}: Action<EduTradingCompleteLessonPayload>) => {
                const newState: EduTradingReduxState = Utils.merge({}, state);
                const courses: EduTreeCourse[] = Utils.deepCopy(newState.Courses);
                const currentCourse = courses?.find(item=> item.Id === payload.courseId);
                if (currentCourse) {
                    currentCourse.Sections.forEach(section =>{
                        section.Lessons?.forEach(lesson => {
                            if (lesson.LessonGuid === payload.lessonGuid) {
                                lesson.IsCompleted = true;
                            }
                        })
                    })
                }
                newState.Courses = courses;
                return newState;
            })
            .handle(EduTradingSetTrendAnalysisResolution, (state: EduTradingReduxState, {payload}: Action<EduTradingSetTrendAnalysisResolutionPayload>) => {
                return Object.assign({}, state, {
                    trendAnalysisResolution: payload.resolution,
                });
            })
            .handle(EduTradingSetTrendAnalysisAsset, (state: EduTradingReduxState, {payload}: Action<EduTradingSetTrendAnalysisAssetPayload>) => {
                return Object.assign({}, state, {
                    trendAnalysisAsset: payload.asset,
                });
            });
    }
}

